import { Button } from "primereact/button";
import { Card } from "primereact/card";
import { InputText } from "primereact/inputtext";

const CheckoutSummaryCard = ({
  totalItems,
  displaySubtotal,
  displayIva,
  displayShipping,
  displayTotal,
  onDownloadCotizacion,
  onOpenSpecialistWhatsApp,
  coupon,
  detail,
}) => {
  const lineas = [
    ...(detail?.lineasAfectas || []),
    ...(detail?.lineasNoAfectas || []),
  ];

  return (
    <Card className="getnet-summary-card">

      <h3><b>Resumen de compra</b></h3>

      <div className="flex flex-column gap-3">
        {lineas.length > 0 && (
          <div className="flex flex-column gap-2">
            {detail.tieneCupon && detail.cupon && (
              <div className="flex justify-content-between align-items-center">
                <span>{detail.cupon.titulo}</span>
                <span>-{detail.cupon.descuento}%</span>
              </div>
            )}
            {lineas.map((linea) => (
              <div key={linea.id} className="flex flex-column gap-1">
                <div className="flex justify-content-between align-items-center">
                  <strong>{linea.glosa}</strong>
                  <span>x{linea.cantidad}</span>
                </div>
                <div className="flex justify-content-between align-items-center text-color-secondary">
                  <small>Valor unit.</small>
                  <small>${linea.valorUnitario.toLocaleString("es-CL")}</small>
                </div>
                <div className="flex justify-content-between align-items-center">
                  <small>Total</small>
                  <small>{linea.total.toLocaleString("es-CL")}</small>
                </div>
                {linea.descuentoCupon > 0 && (
                  <div className="flex justify-content-between align-items-center">
                    <small>Desc. cupón</small>
                    <small>{linea.totalConDescuento}</small>
                  </div>
                )}
              </div>
            ))}
            {detail.tieneCupon && (
              <div className="flex justify-content-between align-items-center ">
                <span>Descuento cupón</span>
                <strong>{detail.montoDescuentoCupon}</strong>
              </div>
            )}
          </div>

        )}


        <div className="flex justify-content-between align-items-center mt-2 pt-3 border-1 border-300 border-bottom-none border-left-none border-right-none">
          <span>Productos</span>
          <strong>{totalItems}</strong>
        </div>
        <div className="flex justify-content-between align-items-center">
          <span>Despacho</span>
          <strong>{displayShipping}</strong>
        </div>
        <div className="flex justify-content-between align-items-center">
          <span>Subtotal</span>
          <strong>{displaySubtotal}</strong>
        </div>
        <div className="flex justify-content-between align-items-center">
          <span>IVA</span>
          <strong>{displayIva}</strong>
        </div>

        <div className="flex flex-column gap-2 mt-2">
          <div className="flex gap-2 align-items-center">
            <InputText
              value={coupon.couponCode}
              onChange={(e) => coupon.setCouponCode(e.target.value)}
              placeholder="Ingrese código"
              disabled={coupon.couponApplied}
              className="flex-1"
              autoComplete="off"
            />
            {!coupon.couponApplied ? (
              <Button
                label="Aplicar"
                loading={coupon.couponLoading}
                onClick={coupon.handleApplyCoupon}
              />
            ) : (
              <Button
                label="Quitar"
                onClick={coupon.handleRemoveCoupon}
                outlined
              />
            )}
          </div>
          {coupon.couponMessage && (
            <small className="text-color-secondary">{coupon.couponMessage}</small>
          )}
        </div>

        <div className="flex justify-content-between align-items-center mt-2 pt-3 border-1 border-300 border-top-none border-left-none border-right-none">
          <span className="font-bold text-lg">Total</span>
          <strong className="text-xl">{displayTotal}</strong>
        </div>
      </div>

      <div className="flex gap-2 mt-4">
        <Button
          label="Descargar cotización"
          icon="pi pi-download"
          outlined
          rounded
          onClick={onDownloadCotizacion}
          className="flex-1"
        />
        <Button
          label="Ver con Especialista"
          icon="pi pi-whatsapp"
          rounded
          onClick={onOpenSpecialistWhatsApp}
          className="flex-1"
          style={{ backgroundColor: "#22c55e", borderColor: "#22c55e" }}
        />
      </div>
    </Card>
  );
};

export default CheckoutSummaryCard;
